export default "__VITE_ASSET__cO4LARux__"